/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Stack, Chip, Container, Grid2 } from "@mui/material";
import { getConfig } from "../../config";
import "./ApplicationDetailsCategory.css";

function ApplicationDetailsCategory({ submissionData, categoryData }) {
  const [categoryValue, setCategoryValue] = useState([]);
  const thirdPartyApps = globalThis.location.href.includes("third-party-apps");
  useEffect(() => {
    if (
      getConfig().REACT_APP_PORTAL === "seller" ||
      getConfig().REACT_APP_PORTAL === "global-admin" ||
      (getConfig().REACT_APP_PORTAL === "domain-approver" &&
        !thirdPartyApps &&
        submissionData &&
        Object.keys(submissionData).length > 0 &&
        submissionData.categoryIds &&
        submissionData.categoryIds.length > 0)
    ) {
      const newCategoryValue = categoryData.filter((ele) => {
        let categoryindex = submissionData.categoryIds.findIndex(
          (el) => el == ele.id
        );
        if (categoryindex !== -1) {
          return ele;
        }
      });
      setCategoryValue([...newCategoryValue]);
    } else if (
      (getConfig().REACT_APP_PORTAL === "oem-admin" ||
        (getConfig().REACT_APP_PORTAL === "domain-approver" &&
          thirdPartyApps)) &&
      submissionData &&
      Object.keys(submissionData).length > 0 &&
      submissionData.tags &&
      submissionData.tags.length > 0
    ) {
      const tags = submissionData.tags;

      let categoryOemAdmin = tags.find((tagValue) => {
        if (tagValue.key === "category") return tagValue.values;
      });

      setCategoryValue([...categoryOemAdmin.values]);
    }
  }, [submissionData, categoryData]);

  return (
    <Container maxWidth="lg">
      <Grid2 container>
        <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
          <div
            className={
              submissionData &&
              Object.keys(submissionData).length > 0 &&
              submissionData.status !== "DRAFT"
                ? "categoryDiv categoryDiv-border"
                : "categoryDiv"
            }
            id="category"
            style={{
              marginLeft: "10%",
              borderBottom:
                submissionData &&
                Object.keys(submissionData).length > 0 &&
                submissionData.status !== "DRAFT"
                  ? "1px solid rgba(18, 20, 21, 0.2) !important"
                  : "0px !important",
            }}
          >
            <p className="category-text">Category</p>
            {submissionData &&
            Object.keys(submissionData).length > 0 &&
            categoryData &&
            categoryData.length > 0 ? (
              <Stack
                direction="row"
                spacing={2}
                sx={{ marginBottom: "25px !important" }}
              >
                {categoryValue?.map((catgry, index) => {
                    return (
                      <Chip
                        key={catgry.id}
                        id={catgry.id}
                        label={
                          catgry.translatedNames[
                            submissionData.defaultLanguage
                          ] === undefined
                            ? catgry.translatedNames["en-US"]
                            : catgry.translatedNames[
                                submissionData.defaultLanguage
                              ]
                        }
                        className="chip-text"
                        style={{
                          height: "24px",
                          borderRadius: "5px",
                          marginRight: "8px",
                          // marginBottom: "8px",
                          marginTop: "-4px",
                        }}
                      ></Chip>
                    );
                  })}
              </Stack>
            ) : (
              submissionData &&
              Object.keys(submissionData).length > 0 && (
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{ marginBottom: "25px !important" }}
                >
                  {categoryValue?.map((catgry) => {
                      return (
                        <Chip
                          key={catgry}
                          id={catgry}
                          label={catgry}
                          className="chip-text"
                          style={{
                            borderRadius: "5px",
                            marginRight: "5px",
                            marginBottom: "5px",
                          }}
                        ></Chip>
                      );
                    })}
                </Stack>
              )
            )}
          </div>
        </Grid2>
      </Grid2>
    </Container>
  );
}

ApplicationDetailsCategory.propTypes = {
  submissionData: PropTypes.object,
  categoryData: PropTypes.array,
};

export default ApplicationDetailsCategory;

